angular.module('dnecom.component.currency')
    .directive('currencyChange', ["CurrencyRates", "CurrencyConverter", "CurrencyFormatter", function(CurrencyRates, CurrencyConverter, CurrencyFormatter) {
        return {
            restrict: 'E',
            scope: {
                amount: "="
            },
            template: "{{ getFormattedAmount() }}",
            link: function(scope) {
                scope.convertedAmount = CurrencyConverter.convert(
                    scope.amount, CurrencyRates.fetchInitialRate()
                );

                scope.getFormattedAmount = function() {
                    return CurrencyFormatter.format(scope.convertedAmount, CurrencyRates.fetchCurrentCurrency());
                };

                scope.$watch('amount', function(newValue, oldValue) {
                    if (newValue === oldValue) {
                        return;
                    }

                    CurrencyRates.fetchCurrentRate().then(function(currency) {
                        scope.convertedAmount = CurrencyConverter.convert(
                            newValue,
                            currency.rate
                        );
                    });
                });

                scope.$on('currency.convert', function (e, currency) {
                    scope.convertedAmount = CurrencyConverter.convert(
                        scope.amount,
                        currency.rate
                    );
                });
            }
        };
    }]);
